<div
    class="anc-summary-row"
    [class.anc-summary-row--readonly]="readonly()"
    [class.anc-summary-row--emphasized]="emphasized()"
>
    <label class="anc-summary-row__label">{{ label() | translate }}</label>
    <div class="anc-summary-row__value">
        <ng-content></ng-content>
    </div>
</div>
<div class="anc-summary-row__error">
    <ng-content select="[ancSummaryRowError]"></ng-content>
</div>
